export const HeaderConstants = {
  // Search
  SEARCH_INPUT_PLACEHOLDER: "Search Products...",

  // Shop by category
  SHOP_BY_CATEGORY: "Categories",
  SEE_ALL_CATEGORIES: "See all Categories",

  // Navigation labels
  SPECIAL_DEALS: "DAILY ESSENTIALS SPECIAL DEALS",
  REQUEST_FOR_QUOTES: "Smart Quotation",
  IB_CREDIT: "Buy On Credit",
  HELP_CENTER: "Help Center",

  // Secondary links
  WRITE_TO_MANAGEMENT: "Write to Management",
  TRACK_ORDER: "Track Order",
  REVIEW_PRODUCT: "Write Review",
  CHAT_SUPPORT: "Chat",
  BLOG: "Blog",

  // Mobile menu
  OFFERS: "Offers",
  STOCK_CLEARANCE_SALE: "Stock Clearance Sale",
  SALE: "Sale",
  GST_BENEFITS: "GST Benefits",
  BECOME_A_SELLER: "Become a Seller",
  FAQs: "FAQs",
  IOS_APP: "iOS App",
  ANDROID_APP: "Android App",
  CREDIT_HISTORY: "Credit History",

  // User account
  MY_PROFILE: "My Profile",
  MY_ORDERS: "My Orders",

  // Shop by categories
  SHOP_BY_BRAND: "Shop by Brand",
  SHOP_BY_PRICE: "Shop by Price",
  SHOP_BY_MAIN_CATEGORIES: "Shop by Main Categories",
};

export const HeaderLinks = {
  HOME: "/",
  CART: "/order/cart",
  LOGIN: "/user/login",
  ACCOUNT: "/user/account",
  PROFILE_ACCOUNT: "/user/account",
  MY_ORDERS: "/user/orders",
  PROFILE_ORDERS: "/user/orders",
  REQUEST_FOR_QUOTES: "/user/smart-quotation",
  IB_CREDIT: "/ib-credit",
  HELP_CENTER: "/faq",
  GRIEVANCE_REDRESSAL: "/user/grievance-redressal",
  OFFERS: "/offers",
  GST_BENEFITS: "/gst-benefits",
  BLOG: "/articles",
  CREDIT_HISTORY: "/user/credit-history",
  SEE_ALL_CATEGORIES: "/categories",
  WRITE_A_REVIEW: "/user/write-review",
  // Keep in sync with backend GlobalConfigurationConstants.WHATSAPP_WEB_LINK_TEMPLATE
  WHATSAPP_WEB_LINK:
    "https://wa.me/+918448027888?text=Hi Team, I need assistance. Could you please assist?",
};

export const SocialUrls = {
  PLAY_STORE:
    "https://play.google.com/store/apps/details?id=industrybuying.com.industrybuying",
  APP_STORE:
    "https://apps.apple.com/in/app/industrybuying-online-shopping/id1602345204",
  SELLER_URL: "https://seller.industrybuying.com",
};

export const ImagePaths = {
  // Brand
  INDUSTRYBUYING_LOGO:
    "https://static3.industrybuying.com/a-wk/images/webp/website-logo.webp",
  MOBILE_IB_LOGO:
    "https://static3.industrybuying.com/a-wk/images/webp/ib-logo-hd.webp",

  // Contact
  CALL_ICON: "https://static3.industrybuying.com/a-wk/images/svg/call.svg",
  EMAIL_ICON_WHITE:
    "https://static3.industrybuying.com/a-wk/images/webp/email-white-outline.webp",

  // Search
  SEARCH_ICON:
    "https://static3.industrybuying.com/a-wk/images/svg/search-icon.svg",

  // Navigation
  SPECIAL_DEALS:
    "https://static3.industrybuying.com/a-wk/images/webp/add-to-cart.webp",
  REQUEST_FOR_QUOTES:
    "https://static3.industrybuying.com/a-wk/images/webp/request-for-quotes.webp",
  BUY_ON_CREDIT:
    "https://static3.industrybuying.com/a-wk/images/webp/credit-card-check.webp",
  HELP_CENTER:
    "https://static3.industrybuying.com/a-wk/images/webp/faq/faq-chat.webp",

  // User
  ARROW: "https://static3.industrybuying.com/a-wk/images/svg/arrow.svg",
  USER_ICON: "https://static3.industrybuying.com/a-wk/images/svg/user.svg",

  // Cart
  CART_ICON: "https://static3.industrybuying.com/a-wk/images/svg/cart.svg",

  // Categories
  CATEGORY_MENU:
    "https://static3.industrybuying.com/a-wk/images/svg/category-menu.svg",

  // Mobile
  BACK_ARROW:
    "https://static3.industrybuying.com/a-wk/images/webp/ic-back.webp",
  MENU_ICON: "https://static3.industrybuying.com/a-wk/images/webp/menu.webp",
  DROPDOWN: "https://static3.industrybuying.com/a-wk/images/svg/dropdown.svg",

  // Apps
  ANDROID_APP_ICON:
    "https://static3.industrybuying.com/a-wk/images/svg/android.svg",
  IOS_APP_ICON: "https://static3.industrybuying.com/a-wk/images/svg/apple.svg",
};

export const GlobalConfig = {
  CUSTOMER_HELPLINE_NUMBER: "+91 9650660070",
  CUSTOMER_HELPLINE_EMAIL: "care@industrybuying.com",
  WHATSAPP_WEB_LINK_TEMPLATE: "https://wa.me/+91{0}?text={1}",
  WHATSAPP_DEFAULT_MESSAGE:
    "Hi Team, I need assistance. Could you please assist?",
};
